import { PossibleVariants } from 'utils/tracking/optimizely/types'
import type {
  RCEVoucherActiveExperimentVariant,
  RCEVoucherExperimentVariant
} from '../VoucherBanner.types'
import { RCE_VOUCHER_ACTIVATED_NOTICE_PAGES } from '../VoucherBanner.constants'

export type RCEVoucherPresentation =
  | { kind: 'none' }
  | { kind: 'variant-b-edit'; amount: number }
  | { kind: 'variant-c-edit'; amount: number }
  | {
      kind: 'activated-additional'
      amount: number
      variant: RCEVoucherActiveExperimentVariant
    }

interface SelectRCEVoucherPresentationInput {
  variant: RCEVoucherExperimentVariant
  page: string | null
  amount: number | null
  isActivated: boolean
}

export const selectRCEVoucherPresentation = ({
  variant,
  page,
  amount,
  isActivated
}: SelectRCEVoucherPresentationInput): RCEVoucherPresentation => {
  if (variant === PossibleVariants.CONTROL || amount === null) {
    return { kind: 'none' }
  }

  if (page === 'editPage') {
    return variant === PossibleVariants.VARIATION_B
      ? { kind: 'variant-b-edit', amount }
      : { kind: 'variant-c-edit', amount }
  }

  if (
    page &&
    RCE_VOUCHER_ACTIVATED_NOTICE_PAGES.includes(page) &&
    isActivated
  ) {
    return { kind: 'activated-additional', amount, variant }
  }

  return { kind: 'none' }
}
